function popupLink(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    e.preventDefault();

    const data = e.currentTarget.dataset;
    const popupWidth = data.popupWidth ? parseInt(data.popupWidth, 10) : 0;
    const popupHeight = data.popupHeight ? parseInt(data.popupHeight, 10) : 0;
    const w = popupWidth || 626; // What are these obscure numbers?
    const h = popupHeight || 436;

    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : e.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : e.screenY;
    const screenWidth = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : screen.width;
    const screenHeight = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : screen.height;

    const left = screenWidth / 2 - w / 2 + dualScreenLeft;
    const top = screenHeight / 2 - h / 2 + dualScreenTop;

    const windowParams =
        'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no';
    const dimensionParams = 'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left;

    const newWindow = window.open(
        e.currentTarget.getAttribute('href') || undefined,
        '_blank',
        windowParams + ', ' + dimensionParams
    );
    if (newWindow) {
        newWindow.opener = null;

        if (window.focus) {
            newWindow.focus();
        }
    }
}
export default popupLink;



// WEBPACK FOOTER //
// ./src/web/js/app/ui/popupLink.ts